export function escapeRegex(value: string) {
  return value.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
}
